<template>
    <div id="app" class="slides noPreload zoom animated slow font-body text-white">

        <!-- Full page slide dots start -->
        <FullPageSlideDots />
        <!-- Full page slide dots end -->
		
        <!-- Side Mention start -->
        <SideMention />
        <!-- Side Mention end -->

        <!-- Header start -->
        <ThemeHeader />
        <!-- Header end -->

		<!-- Sidebar Menu start -->
        <SideMenu />
		<!-- Sidebar Menu end -->

        <!-- Section 1 start -->
        <Section1
            title1="AGRIC"
            title2="ULTURAL"
            title3="CHIC"
            subtitle="FOR FIELD GARDEN & ROOMS"
            :bgImg="section1Bg"
        />
        <!-- Section 1 end -->

        <!-- Section 2 start -->
        <Section2
            title="unwanted"
            subtitle="MODERN BLEND OF CLOVE, GERANIUM, TEXAS CEDAR, CITRONELLA AND OTHER INGREDIENTS."
            :bgImg="section2Bg"
        />
        <!-- Section 2 end -->

        <!-- Section 3 start -->
        <Section3 />
        <!-- Section 3 end -->

        <!-- Section 4 start -->
        <Section4
            desc="“We entertained at horse shows with dented mint julep cups and lunched on the back of the station wagons off white Dixie paper plates. The girls sat on horse blankets weathered and tattered by sea salt, bourbon and conversation.”"
            :bgImg="section4Bg"
        />
        <!-- Section 4 end -->

        <!-- Section 5 start -->
        <Section5 />
        <!-- Section 5 end -->

        <!-- Section 6 start -->
        <Section6
            title="UN. DAU. TRI. PEDWAR. PUMP."
            nextbtntext="Mad Jam & Field"
            name="themadjamandfields"
            :bgImg="section6Bg"
        />
        <!-- Section 6 end -->

        <!-- Section 7 start -->
        <Section7 />
        <!-- Section 7 end -->

        <!-- Section 8 start -->
        <Section8 />
        <!-- Section 8 end -->

        <!-- Section 9 start -->
        <Section6
            title="YAN. TAN. TETHER. METHER. PIMP."
            nextbtntext="Black Sheep"
            name="blacksheep"
            :bgImg="section9Bg"
        />
        <!-- Section 9 end -->

        <!-- Section 10 start -->
        <Section10 />
        <!-- Section 10 end -->

        <!-- Section 11 start -->
        <Section6
            title="GET MUDDY."
            titleClass="text-size12"
            nextbtntext="The Field Apron"
            name="fieldapron"
            sectionClass="fieldpron"
            :bgImg="section11Bg"
        />
        <!-- Section 11 end -->

        <!-- Section 12 start -->
        <Section12 />
        <!-- Section 12 end -->

        <!-- Section 13 start -->
        <Section6
            sectionClass="fade-3"
            title="FOR FIELD, GARDEN & ROOMS"
            nextbtntext="FURNITURE"
            name="furniture"
            :bgImg="section13Bg"
        />
        <!-- Section 13 end -->

        <!-- Section 14 start -->
        <Section14 />
        <!-- Section 14 end -->

        <!-- Section 15 start -->
        <Section15
            title1="madison james is a hard to find goods company."
            title2="agricultural chic for field, garden & rooms."
            email="info@madisonjames.net"
            prevBtnText="Copyright © 2024."
            prevBtnText2="Developed By "
            contactbtnTxt="Contact Us"
            contactbtnUrl="mailto:info@madisonjames.net"
            productbtnTxt="View Product Shots"
            productbtnUrl="#"
            developeby="WideThemes"
            devUrl="https://themeforest.net/user/widethemes/portfolio"
            :bgImg="section15Bg"
        />
        <!-- Section 15 end -->
    </div>
</template>

<script>

// Components
import "@/assets/css/style.css";
import FullPageSlideDots from "./components/common/FullPageSlideDots";
import SideMention from "./components/common/SideMention";
import ThemeHeader from "./components/common/ThemeHeader";
import SideMenu from "./components/common/SideMenu";
import Section1 from "./components/sections/Section1";
import Section2 from "./components/sections/Section2";
import Section3 from "./components/sections/Section3";
import Section4 from "./components/sections/Section4";
import Section5 from "./components/sections/Section5";
import Section6 from "./components/sections/Section6";
import Section7 from "./components/sections/Section7";
import Section8 from "./components/sections/Section8";
import Section10 from "./components/sections/Section10";
import Section12 from "./components/sections/Section12";
import Section14 from "./components/sections/Section14";
import Section15 from "./components/sections/Section15";

export default {
    name: "App",
    components: {
        Section15,
        Section14,
        Section12,
        Section10,
        Section8,
        Section7,
        Section6,
        Section5,
        Section4,
        Section3,
        SideMenu,
        Section2,
        Section1,
        ThemeHeader,
        SideMention,
        FullPageSlideDots,
    },
    data() {
        return {
            section1Bg: require("@/assets/images/homescreen3.png"),
            section2Bg: require("@/assets/images/horsebox.png"),
            section4Bg: require("@/assets/images/oilsheep.png"),
            section6Bg: require("@/assets/images/madjam.png"),
            section9Bg: require("@/assets/images/blacksheep.png"),
            section11Bg: require("@/assets/images/getmuddybw.png"),
            section13Bg: require("@/assets/images/window.png"),
            section15Bg: require("@/assets/images/contactus.png"),
        };
    },
};
</script>

<style>
</style>
